import { WizRoot } from './../../components/views/wiz-root';
import { Platform } from '@angular/cdk/platform';
import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { WIZ_EVENT_TYPE, WizDateUtils } from '@wizeoo/akm-core-lib';
import { WizEvent } from '../../events/wiz-event';
import { WizEventManager } from '../../events/wiz-event.manager';
import { WizTranslationManager } from '../../services/translation/wiz-translation.manager';

/**
 * Date adapter custom pour gestion des formats de date
 */
@Injectable()
export class WizNativeDateAdapter extends NativeDateAdapter {

  /**
   * Surcharge du constructeur pour application de la locale et ecoute du changement de langue
   * @param matDateLocale locale material (sera surchargé par le manager de traductions)
   * @param platform platform
   */
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string, platform: Platform) {
    super(matDateLocale, platform);
    this.wizTranslate(null);
    WizEventManager.addListener(this, WizRoot.getInstance().elementRef, WIZ_EVENT_TYPE.TRANSLATION_LOADED, this.wizTranslate);
  }

  /**
   * Application de la locale du manager de traductions
   * @param event Evenement de changement de langue
   */
  private wizTranslate(event: WizEvent): void {
    this.setLocale(WizTranslationManager.getInstance().dateLocale);
  }

  /**
   * Méthode parse à overrider pour gestion des formats par locale
   * @param value la chaine à formater
   */
  public parse(value: any): Date | null {
    if (value instanceof String || typeof (value) === 'string') {
      let strValue: string = value.toString();
      const currentLocale: string = WizTranslationManager.getInstance().dateLocale;
      const dateSeparator: string = WizDateUtils.getLocaleDateSeparator(currentLocale);
      // console.log('WizNativeDateAdapter',currentLocale);

      // collecte du format de la locale
      const localeMask: string = WizTranslationManager.getInstance().translateKey('date.format', null, 'MM/DD/YYYY');
      if (strValue) {
        for (let i = 0; i < WizDateUtils.ACCEPTED_SEPARATORS.length; i++) {
          const char: string = '\\' + WizDateUtils.ACCEPTED_SEPARATORS[i];
          const regexp: RegExp = new RegExp(char, 'g');
          strValue = strValue.replace(regexp, dateSeparator);
        }
      }

      // complétion maximale
      // console.log('WizNativeDateAdapter',strValue,localeMask)
      const wizDate: Date = WizDateUtils.rawStringToDate(strValue, localeMask);
      value = wizDate;
    }
    return super.parse(value);
  }
}
